import { IrisDMSFileI } from '@iris/common/modules/dms/models/IrisDMSFile';
import { IrisDMSFolderI } from '@iris/common/modules/dms/models/IrisDMSFolder';

export type IrisDMSFolderOrFile = IrisDMSFileI | IrisDMSFolderI;

export const isFile = (data: IrisDMSFolderOrFile): boolean => {
  return !isFolder(data);
};

export const isFolder = (data: IrisDMSFolderOrFile): boolean => {
  const property: keyof IrisDMSFolderI = 'hasChildren';
  return !!data && data.hasOwnProperty(property);
};
